import { ThemeProvider } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";

import { App } from "./app.tsx";
import "./lib/sentry";
import { LicenseInfo } from "@mui/x-license";

import { MaintenancePage } from "./components/feature/maintenance";
import { initFirebase } from "./lib/firebase.ts";
import { theme } from "./lib/theme/mui-theme";

// Set the license key from your environment variable
const licenseKey = import.meta.env.VITE_MUI_X_LICENSE_KEY;
if (licenseKey) {
  LicenseInfo.setLicenseKey(licenseKey);
}

// Check if maintenance mode is enabled
const isMaintenanceMode = import.meta.env.VITE_MAINTENANCE_MODE === "true";

if (!isMaintenanceMode) {
  initFirebase();
}

// Render the app
const rootElement = document.getElementById("app");
if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);

  // Show maintenance page if maintenance mode is enabled
  const app = isMaintenanceMode ? (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <MaintenancePage />
    </ThemeProvider>
  ) : import.meta.env.DEV ? (
    <StrictMode>
      <App />
    </StrictMode>
  ) : (
    <App />
  );

  root.render(app);
}
